exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-html-container .form-control[data-v-8db18bd4]{width:100%}", ""]);

// exports
